import React, { Component } from "react";
import UIView from "./UIView";
import StateView from "./StateView";

class VMView extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  componentDidMount() {
    console.log("componentDidMount VMView ");
  }

  render() {
    return (
      <div
        className="VM"
        onClick={e => {
          e.stopPropagation();
          this.handleClick(e);
        }}
      >
        <span className="VMTitle">{this.props.vm.get("name")}</span>
        {this.props.children}
      </div>
    );
  }
}

export default VMView;



// WEBPACK FOOTER //
// ./src/components/VMView.js